import script from "./bi-tmpl-detail-16.vue?vue&type=script&lang=ts&setup=true"
export * from "./bi-tmpl-detail-16.vue?vue&type=script&lang=ts&setup=true"

import "./bi-tmpl-detail-16.vue?vue&type=style&index=0&id=3670e2e8&lang=scss&scope=true"

const __exports__ = script;

export default __exports__